import Section from 'pxc-editor-core/entities/Section';
import { SECTION_SUFFIX } from '@/constants';

export default payload => {
  const { withoutFormatting = false, targetShield, sourceShield, sourceSection } = payload;
  const shieldId = targetShield.id;
  const x = targetShield.primitiveProps.x + (sourceSection.x - sourceShield.primitiveProps.x);
  const y = targetShield.primitiveProps.y + (sourceSection.y - sourceShield.primitiveProps.y);
  const width = sourceSection.width;
  const height = sourceSection.height;
  const copiedSection = Section.fromDict(sourceSection).clone();
  const result = {
    ...withoutFormatting ? {} : copiedSection,
    x,
    y,
    width,
    height,
    id: `${shieldId}${SECTION_SUFFIX}${Section.counter}`,
    shieldId,
    sourceSectionId: sourceSection.id,
  };
  return result;
};
